import axios from 'axios';

export default class ChecklistService {
   static async all() {
      const url = `/api/checklist-categories/`;
      const response = await axios.get(url);
      return response.data;
   }
}
